import { i18n, Messages } from "@lingui/core";
import { Locale } from "date-fns";
import { de, enUS } from "date-fns/locale";

export interface LocaleDefinition {
  id: string;
  name: string;
  importFunc: () => Promise<{ messages: Messages }>;
  dateFnsLocale: Locale;
  flag: string;
}

export const locales: LocaleDefinition[] = [
  {
    id: "en",
    name: "English",
    importFunc: async () => await import(`./locales/en/messages.po`),
    dateFnsLocale: enUS,
    flag: "🇬🇧",
  },
  {
    id: "de",
    name: "Deutsch",
    importFunc: () => import(`./locales/de/messages.po`),
    dateFnsLocale: de,
    flag: "🇩🇪",
  },
];

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function dynamicActivate(locale: LocaleDefinition) {
  const { messages } = await locale.importFunc();
  i18n.load(locale.id, messages);
  i18n.activate(locale.id);
}

const browserLanguages = window.navigator.languages || [
  window.navigator.language,
];

export const findAndActivateLocale = async (langId: string) => {
  const localeDefinition = locales.find((locale) => locale.id === langId);
  if (localeDefinition) {
    await dynamicActivate(localeDefinition);
    return localeDefinition;
  }
  console.error(`Unable to activate locale with id ${langId}`);
  throw new Error();
};

export async function initialize() {
  const localeKeys = locales.map((locale) => locale.id);
  const supportedPreferences = browserLanguages
    .map((value) => value.split("-")[0])
    .filter((value) => localeKeys.includes(value));
  if (supportedPreferences[0]) {
    return await findAndActivateLocale(supportedPreferences[0]);
  } else {
    return await findAndActivateLocale("en");
  }
}
